import i18n from '@/i18n'
import Swal from 'sweetalert2'

const onlyAdministratorFunctionAlert = () => {
    return Swal({
        type: 'warning',
        title: i18n.t('notification.permissions.onlyAdministratorFunction'),
        cancelButtonText: i18n.t(`modal.close`),
        showCancelButton: false,
        showConfirmButton: true,
    })
}
const noSelectedUsersAlert = () => {
    return Swal({
        type: 'warning',
        title: i18n.t('people.noUserSelected'),
        showCancelButton: false,
        showConfirmButton: true,
    })
}

const usersWithoutValuesSelectedAlert = names => {
    const div = document.createElement('div')
    const list = document.createElement('ul')
    list.className = 'list-group'

    names.forEach(name => {
        const item = document.createElement('li')
        const content = document.createTextNode(name)

        item.appendChild(content)
        item.className =
            'd-flex list-group-item justify-content-between align-items-center'
        list.appendChild(item)
    })

    div.appendChild(list)

    return Swal({
        html: div,
        type: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: i18n.t(`modal.close`),
        title: i18n.t('notification.usersWithoutValuesSelected'),
    })
}

export {
    noSelectedUsersAlert,
    onlyAdministratorFunctionAlert,
    usersWithoutValuesSelectedAlert,
}
